<template>
  <div class="row" style="width: 100%">
    <div class="col-md-6 px-gap" id="postMediaKon">
      <div class="row" style="height: 100%">
        <div class="col-md-12 px-gap">
          <div
            class="bg-white p-t-20 p-b-20 rounded shade h-100"
            data-v-step="10"
          >
            <h5 class="no-margin" align="center">
              Berita Terbaru Media Konvensional
            </h5>
            <div class="p-t-10">
              <tab-horizontal-component :tabs="data_tab_formed" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mt-md-0 m-t-10" id="postMedsos">
      <div class="row" style="height: 100%">
        <div class="col-md-12">
          <div
            class="bg-white p-l-20 p-t-20 p-r-20 rounded shade h-100"
            data-v-step="11"
          >
            <h5 class="no-margin" align="center">Post Media Sosial</h5>
            <div class="p-t-10">
              <tab-horizontal-component :tabs="data_tab_medsos" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tab_horizontal from "@/views/components/tab_horizontal.vue";

export default {
  name: "post_list",
  components: {
    "tab-horizontal-component": tab_horizontal,
  },
  props: {
    data_tab_medsos: Array,
    data_tab_formed: Array,
    display_tipe: Number,
  },
};
</script>
